import { ecboClient, getHeaderLocale } from 'lib/axios'

import type { FacilitiesByPrefectureResponse } from 'features/facility/types/facility'

const API_FACILITIES = '/api/web/facilities'

export const fetchFacilitiesByPrefecture = async (
  prefectureId: number,
  locale: string,
  type?: 'facility' | 'station'
) => {
  const response = await ecboClient.get<FacilitiesByPrefectureResponse>(API_FACILITIES, {
    params: {
      prefecture_id: prefectureId,
      ...(type !== undefined ? { type } : {}),
    },
    headers: { 'Accept-Language': getHeaderLocale(locale) },
  })
  return {
    isOk: true as const,
    data: response.data,
  }
}

export const getStations = (prefectureId: number, locale: string) =>
  fetchFacilitiesByPrefecture(prefectureId, locale, 'station')

export const getFacilities = (prefectureId: number, locale: string) =>
  fetchFacilitiesByPrefecture(prefectureId, locale, 'facility')
